import { Location } from "react-router"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

export interface BrowserLocationState extends Location {
  setBrowserLocation: (location: Location) => void
}

export const useBrowserLocation = create<BrowserLocationState>()(
  devtools((set) => ({
    setBrowserLocation: (location) => set(location),
  })),
)
